import { createFileRoute } from '@tanstack/react-router';
import EditEvent from '~/containers/Experiences/EditEvent';

export const Route = createFileRoute(
  '/experiences/$experienceId/events/$eventId/edit'
)({
  component: EditEvent,
});
